import { queryClient } from "App";
import axiosInstance from "axiosConfig";
import { TOAST_TYPES_ENUM } from "enums";
import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import { Toast } from "shared";
import { toast } from "react-toastify";
import { SESSION_QUERY_KEY } from "./CheckSessionHook";

export type LogoutSuccessorResponse = { status: "success"; authorized?: boolean };

export const useLogoutSuccessor = (
  options?: UseMutationOptions<LogoutSuccessorResponse, any, void>
) => {

  return useMutation({
    mutationKey: ["successors", "logout"],
    mutationFn: async () => {
      const res = await axiosInstance.get(`/successors/logout`);
      return res.data as LogoutSuccessorResponse;
    },
    onMutate: (variables) => {
      Toast({
        message: "Wylogowywanie z zakładki Sukcesja…",
        type: TOAST_TYPES_ENUM.LOADING,
        id: "logout-successor",
      });
      return options?.onMutate?.(variables);
    },
    onSuccess: async (data, variables, context) => {
      Toast({ message: "Wylogowano pomyślnie", type: TOAST_TYPES_ENUM.SUCCESS, id: "logout-successor" });

      await queryClient.invalidateQueries({ queryKey: SESSION_QUERY_KEY });
      await queryClient.removeQueries({ queryKey: SESSION_QUERY_KEY });

      queryClient.setQueryData(SESSION_QUERY_KEY, { authorized: false, status: "success" });

      options?.onSuccess?.(data, variables, context);
    },

    onError: (error: any, variables, context) => {
      const status = error?.status ?? error?.response?.status;
      if (status === 401) {
        Toast({ message: "Nieautoryzowany dostęp", type: TOAST_TYPES_ENUM.ERROR, id: "logout-successor" });
      } else if (status === 500) {
        Toast({ message: "Błąd serwera", type: TOAST_TYPES_ENUM.ERROR, id: "logout-successor" });
      } else {
        toast.dismiss("logout-successor");
      }

      options?.onError?.(error, variables, context);
    },
  });
};
